export default class ModelSearch {

    constructor() {
        if (document.querySelector('#modelSearchForm') === null) {
            return;
        }

        this.init();
    }

    init() {
        const forms = document.querySelectorAll('.model-search-form');

        forms.forEach(form => {
            const brandSelect = form.querySelector('.brand-select');
            const typeSelect = form.querySelector('.type-select');
            const yearSelect = form.querySelector('.year-select');
            const urlParams = new URLSearchParams(window.location.search);

            form.addEventListener('submit', event => {
                if (brandSelect.value === '' || typeSelect.value === '' || yearSelect.value === '') {
                    alert('Kies de juiste motor');
                    event.preventDefault();
                }
            });

            let typeRequest;
            brandSelect.addEventListener('change', event => {
                typeSelect.innerHTML = '<option value="">Een ogenblik geduld</option>';
                yearSelect.innerHTML = '<option value="">Een ogenblik geduld</option>';

                typeRequest = fetch('/zoeken-op-model/types', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                    body: JSON.stringify({
                        brand: brandSelect.value,
                    }),
                })
                    .then(response => response.text())
                    .then(data => {
                        if (data) {
                            typeSelect.innerHTML = data;
                            yearSelect.innerHTML = '<option value="">Kies een type</option>';

                            const options = typeSelect.querySelectorAll('option');
                            const optionValue = urlParams.get('type') ? urlParams.get('type') : form.dataset.type;
                            options.forEach(option => {
                                if (optionValue !== '' && option.value === optionValue) {
                                    option.selected = true;
                                    typeSelect.dispatchEvent(new Event('change'));
                                }
                            });
                        } else {
                            typeSelect.innerHTML = '<option value="">Kies eerst merk</option>';
                            yearSelect.innerHTML = '<option value="">Kies eerst merk</option>';
                        }
                    });
            });

            let yearRequest;
            typeSelect.addEventListener('change', event => {
                yearSelect.innerHTML = '<option value="">Een ogenblik geduld</option>';

                yearRequest = fetch('/zoeken-op-model/jaren', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                    body: JSON.stringify({
                        type: typeSelect.value,
                    }),
                })
                    .then(response => response.text())
                    .then(data => {
                        yearSelect.innerHTML = data;

                        const options = yearSelect.querySelectorAll('option');
                        const optionValue = urlParams.get('year') ? urlParams.get('year') : form.dataset.year;
                        options.forEach(option => {
                            if (option.value === optionValue) {
                                option.selected = true;
                            }
                        });
                    });
            });

            if (urlParams.get('type') || form.dataset.type !== '') {
                brandSelect.dispatchEvent(new Event('change'));
            }
        });
    };
}
